function generateRandomString() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < 8; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    // result 增加两位数年份前缀
    result = new Date().getFullYear().toString().substring(2) + result;
    return result;
}
module.exports = {
    generateRandomString
}   